import { apiFetch } from "./client";
import type { Booking, DayNote, PlannerDay } from "./types";

/** Load Planner API client (Outlook-style day view). */

export interface PlannerMovePayload {
  load_id: number;
  bay_id: number;
  start_utc: string;
  end_utc: string;
}

export async function getPlannerDay(day: string): Promise<PlannerDay> {
  const qs = new URLSearchParams({ day });
  return apiFetch<PlannerDay>(`/planner/day?${qs.toString()}`);
}

export interface PlannerLegMovePayload {
  leg_id: number;
  bay_id: number;
  start_utc: string;
  end_utc: string;
}

export async function movePlannerLoad(data: PlannerMovePayload): Promise<Booking> {
  return apiFetch<Booking>("/planner/move", { method: "POST", body: JSON.stringify(data) });
}

/** Move a single collection leg (its site + collection time), not the load. */
export async function movePlannerLeg(data: PlannerLegMovePayload): Promise<{ status: string }> {
  return apiFetch<{ status: string }>("/planner/leg-move", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function getDayNote(day: string): Promise<DayNote> {
  const qs = new URLSearchParams({ day });
  return apiFetch<DayNote>(`/planner/notes?${qs.toString()}`);
}

export async function saveDayNote(data: { day: string; note: string | null }): Promise<DayNote> {
  return apiFetch<DayNote>("/planner/notes", { method: "PUT", body: JSON.stringify(data) });
}
